import { Responsive } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { Feedback } from '../../components/Feedback';
import { selectBuilderId } from '../../selectors/builder';
import { ShowContactsContainer } from '../ShowContactsContainer';
import { trackShowPhoneClick } from '../../utils/tracking';
import { useEventCallback } from '@cian/react-utils';
import { CallbackButtonContainer } from '../CallbackButtonContainer';
import { ECallbackWidgetPlacement } from '../../types/callbackWidget';
import { CallButtonContainer } from '../CallButtonContainer';

export const FeedbackContainer = () => {
  const builderId = useSelector(selectBuilderId);

  const handleCallButtonClick = useEventCallback(() => {
    trackShowPhoneClick(builderId);
  });

  return (
    <Responsive phone tablet>
      <Feedback>
        <Responsive phone>
          <CallButtonContainer size="M" onClick={handleCallButtonClick} />
        </Responsive>
        <Responsive tablet>
          <ShowContactsContainer />
        </Responsive>
        <CallbackButtonContainer placement={ECallbackWidgetPlacement.Feedback} />
      </Feedback>
    </Responsive>
  );
};
